
export const OPEN_CREATE_DIRECTORY_FORM_EVENT_TYPE = 'open-directory-form';
export const OPEN_EDIT_DIRECTORY_FORM_EVENT_TYPE = 'open-edit-directory-form';

export interface OpenEditDirectoryEvent {
  localId: number;
  name: string;
  _id?: string;
}

export function isOpenEditDirectoryEvent(
  detail: unknown
): detail is OpenEditDirectoryEvent {
  if (typeof detail !== 'object' || detail === null || Array.isArray(detail)) {
    return false;
  }
  const localId = Object.getOwnPropertyDescriptor(detail, 'localId')?.value;
  const name = Object.getOwnPropertyDescriptor(detail, 'name')?.value;
  return typeof localId === 'number' && typeof name === 'string';
}

export interface OpenCreateDirectoryOptions {
  parentId?: string;
  onSubmitSuccess?: () => void;
}

export function openDirectoryForm(
  directory?: OpenEditDirectoryEvent,
  createOptions?: OpenCreateDirectoryOptions
): void {
  if (directory) {
    window.dispatchEvent(
      new CustomEvent<OpenEditDirectoryEvent>(OPEN_EDIT_DIRECTORY_FORM_EVENT_TYPE, {
        detail: { localId: directory.localId, name: directory.name, _id: directory._id },
      })
    );
  } else {
    window.dispatchEvent(
      new CustomEvent<OpenCreateDirectoryOptions>(
        OPEN_CREATE_DIRECTORY_FORM_EVENT_TYPE,
        { detail: createOptions ?? {} }
      )
    );
  }
}

export function listenToOpenCreateDirectoryForm(
  callback: (event: CustomEvent<OpenCreateDirectoryOptions>) => void
): () => void {
  const handler = (event: Event) => callback(event as CustomEvent<OpenCreateDirectoryOptions>);
  window.addEventListener(OPEN_CREATE_DIRECTORY_FORM_EVENT_TYPE, handler);
  return () => window.removeEventListener(OPEN_CREATE_DIRECTORY_FORM_EVENT_TYPE, handler);
}

export function listenToOpenEditDirectoryForm(
  callback: (event: CustomEvent<OpenEditDirectoryEvent>) => void
): () => void {
  const handler = (event: Event) => callback(event as CustomEvent<OpenEditDirectoryEvent>);
  window.addEventListener(OPEN_EDIT_DIRECTORY_FORM_EVENT_TYPE, handler);
  return () => window.removeEventListener(OPEN_EDIT_DIRECTORY_FORM_EVENT_TYPE, handler);
}
